<div class="och-wrapper">
  @if ((settings$ | async); as settings) {
    <div [innerHTML]="brandStyles(settings)"></div>
    <affiliate-cookie-tracking></affiliate-cookie-tracking>
    <third-party-scripts-injector></third-party-scripts-injector>
    <google-analytics-integration></google-analytics-integration>
    <facebook-integration></facebook-integration>
    @if (isNotEmbed()) {
      <paypal-integration></paypal-integration>
    }
    <instructor-chat></instructor-chat>
    <rewardful-integration></rewardful-integration>
    <source-tracking></source-tracking>
    <mix-panel-integration></mix-panel-integration>
    @defer (when isStudentEnrollmentSettingsPresent) {
    <student-enrolment-dialog-container/>
  }
  <!-- social-media-bar-start -->
  @defer (when (loadSocialMediaBar()) ) {
  @if (loadSocialMediaBar()) {
    <social-media-widget/>
  }
}
<!-- social-media-bar-end -->

<!-- @defer(when settings?.showNewYearUpgradeOffer) {
@if(settings?.showNewYearUpgradeOffer) {
  <new-year-banner />
}
} -->

@defer(when settings?.showBlackFridayUpgradeOffer) {
@if(settings?.showBlackFridayUpgradeOffer) {
  <black-friday-banner />
}
}
@defer(when settings?.showLiveSolutionBanner) {
@if(settings?.showLiveSolutionBanner) {
  <live-session-bar />
}
}
@if (settings?.sessionLanguage) {
  <div class="top-menu-container">
    @defer(when settings?.showAppSumoUpgradeOffer) {
    @if (settings?.showAppSumoUpgradeOffer) {
      <app-sumo-banner />
    }
  }
  <live-session-bar></live-session-bar>
  <!-- <top-discount-banner *ngIf="settings?.showTopBanner" /> -->
  @if (!isPlatformLogin) {
    <top-menu />
  }
</div>
<div class="app-messages-container">
  <messages></messages>
</div>
@defer(when (isAiChatVisible$ | async) ) {
<ai-global-chat></ai-global-chat>
}
<main>
  <!--[style.padding-top.px]="settings?.showTopBanner ? 65 : 0"-->
  <router-outlet></router-outlet>
</main>
}
<loading [detectLazyLoading]="true"></loading>
}
</div>
